import { render, staticRenderFns } from "./SelloEstado.vue?vue&type=template&id=162f0bdb"
import script from "./SelloEstado.vue?vue&type=script&lang=js"
export * from "./SelloEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports